/**
 * @flow
 * @relayHash a22bd20163bc37ccefd8a9c4f35820b2
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type PaymentExportAdminQueryResponse = {|
  +admin: ?{| |};
|};
*/


/*
query PaymentExportAdminQuery(
  $startDate: Date!
  $endDate: Date!
) {
  admin {
    ...PaymentExport_admin
  }
}

fragment PaymentExport_admin on Admin {
  payments(startDate: $startDate, endDate: $endDate) {
    jobSessionId
    paymentStudent
    acceptedJobOfferId
    merchantReference
    jobStatus
    jobSessionStatus
    paymentStatus
    jobCreatedDate
    jobStartDate
    jobDuration
    requestType
    paymentStartedDate
    paymentProviderAmount
    jobId
    paymentTutor
    paymentInternal
    paymentExternal
    studentName
    studentCell
    tutorName
    tutorCell
    tutorAccountHolder
    tutorAccountNumber
    tutorBank
    tutorBranchCode
    tutoringCompanyName
    tutoringCompanyCode
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "startDate",
        "type": "Date!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "endDate",
        "type": "Date!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentExportAdminQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Admin",
        "name": "admin",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "PaymentExport_admin",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "PaymentExportAdminQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "startDate",
        "type": "Date!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "endDate",
        "type": "Date!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "PaymentExportAdminQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Admin",
        "name": "admin",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "endDate",
                "variableName": "endDate",
                "type": "Date!"
              },
              {
                "kind": "Variable",
                "name": "startDate",
                "variableName": "startDate",
                "type": "Date!"
              }
            ],
            "concreteType": "PaymentExport",
            "name": "payments",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "jobId",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "jobSessionId",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "acceptedJobOfferId",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "merchantReference",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "jobStatus",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "jobSessionStatus",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "paymentStatus",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "jobCreatedDate",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "jobStartDate",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "jobDuration",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "requestType",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "paymentStartedDate",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "paymentProviderAmount",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "paymentStudent",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "paymentTutor",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "paymentInternal",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "paymentExternal",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "studentName",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "studentCell",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "tutorName",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "tutorCell",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "tutorAccountHolder",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "tutorAccountNumber",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "tutorBank",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "tutorBranchCode",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "tutoringCompanyName",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "tutoringCompanyCode",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query PaymentExportAdminQuery(\n  $startDate: Date!\n  $endDate: Date!\n) {\n  admin {\n    ...PaymentExport_admin\n  }\n}\n\nfragment PaymentExport_admin on Admin {\n  payments(startDate: $startDate, endDate: $endDate) {\n    jobSessionId\n    paymentStudent\n    acceptedJobOfferId\n    merchantReference\n    jobStatus\n    jobSessionStatus\n    paymentStatus\n    jobCreatedDate\n    jobStartDate\n    jobDuration\n    requestType\n    paymentStartedDate\n    paymentProviderAmount\n    jobId\n    paymentTutor\n    paymentInternal\n    paymentExternal\n    studentName\n    studentCell\n    tutorName\n    tutorCell\n    tutorAccountHolder\n    tutorAccountNumber\n    tutorBank\n    tutorBranchCode\n    tutoringCompanyName\n    tutoringCompanyCode\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/modules/financial/__generated__/PaymentExportAdminQuery.graphql.js